import steps from '../../assets/Steps.png';
import bloodPressure from '../../assets/Blood.png';
import height from '../../assets/Height.png';
import weight from '../../assets/Weight.png';
import heartRate from '../../assets/HeartRate.png';
import breathingPattern from '../../assets/BreathingPattern.png';

export const DATA_OPTIONS = [
  { label: 'Steps', value: 'STEPS', icon: steps },
  { label: 'Blood Pressure', value: 'BLOODPRESSURE', icon: bloodPressure },
  { label: 'Height', value: 'HEIGHT', icon: height },
  { label: 'Weight', value: 'WEIGHT', icon: weight },
  { label: 'Heart Rate', value: 'HEARTRATE', icon: heartRate },
  { label: 'Breathing Pattern', value: 'BREATHINGPATTERN', icon: breathingPattern },
];

export const foo = 'bar';
